<template>
  <b-container fluid>
    <b-card title="Análise de cobrança">
      <metabase :code="295" />
    </b-card>
  </b-container>
</template>
<script>
import {
    BContainer,
    BCard,
} from 'bootstrap-vue';

import Metabase from '../components/Metabase.vue';

export default {
    components: {
        BContainer,
        BCard,
        Metabase,
    },
};
</script>
